<template>
    <div class="row">
        <div class="col-12">
            <div class="alert alert-warning">
                <p class="mb-0" v-if="basket.home_delivery == 0">Our price includes all fitting fees - new rubber valve, balance, old tyre disposal and VAT - what you see is what you pay.</p>
                <p class="mb-0" v-else>Delivered to your home or work in 3-5 working days.</p>
            </div>
        </div>
        <div class="col-12 text-navy">
            <div v-for="(basket_product, key) in basket.products" :key="key" class="basket-product">
                <div v-if="basket_product.product_type == 'product'">
                    <div class="badge bg-navy mb-1" v-if="basket_product.tyre_position != null && basket_product.tyre_position != '' && basket_product.tyre_position != 'same'">
                        <small class="text-uppercase">{{ basket_product.tyre_position }} tyre</small>
                    </div>
                    <div v-else-if="basket_product.tyre_position != null && (basket_product.tyre_position == 'same' || basket_product.tyre_position == '')" class="badge bg-navy mb-1">
                        <small class="text-uppercase">front/rear tyre</small>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{ basket_product.brand }} {{ basket_product.tyre_range }}</span>
                        <span class="d-inline-block float-end">&pound;{{ basket_product.retail }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{ basket_product.size }}</span>
                        <div class="ms-auto">
                            <update-quantity :tyre="basket_product"></update-quantity>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center py-2" v-else>
                    <span class="flex-fill">{{ basket_product.service_name }}</span>
                    <span class="me-3">
                        &pound;{{ parseFloat(basket_product.retail * basket_product.quantity).toFixed(2) }}
                    </span>
                    <button type="button" class="btn btn-secondary" @click="this.deleteServiceFromBasket(basket_product.st_code)">
                        Remove
                    </button>
                </div>
                <hr class="my-2">
            </div>
            <div class="d-flex justify-content-between align-items-center py-2">
                <span>Sub total:</span>
                <span>&pound;{{ basket.sub_total }}</span>
            </div>
            <services v-if="services" :basket="basket" :services="services"></services>
            <service-explained-modal v-if="services" :service="service" :service-explained-modal-open="serviceExplainedModalOpen" @closeModal="serviceExplainedModalOpen = false"></service-explained-modal>
            <div class="d-flex justify-content-between align-items-center py-2" v-if="basket.home_delivery == true && basket.delivery_amount > 0">
                <div class="d-flex align-items-center">
                    <span>Delivery charge:</span>
                    <transition name="fade">
                        <div v-if="deliveryChargeUpdating" class="ms-2 d-flex align-items-center text-primary fw-bold">
                            <i class="fa-solid fa-spinner fa-spin me-1"></i>
                            <b>Updating...</b>
                        </div>
                    </transition>
                </div>
                <span>&pound;{{ basket.delivery_amount }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center py-2" v-if="basket.mobile_fitting > 0">
                <span>Mobile fitting:</span>
                <span>&pound;{{ basket.mobile_fitting }}</span>
            </div>
            <div class="py-1" v-if="basket.disposal_fee > 0">
                <div class="d-flex align-items-center justify-content-between">
                    <b>Environmental Fee:</b>
                    <span>&pound;{{ basket.disposal_fee }}</span>
                </div>
                <disposal-fee-info></disposal-fee-info>
                <hr class="my-2">
            </div>
            <div class="d-flex justify-content-between align-items-center py-2">
                <b class="text-navy">Total:</b>
                <b>&pound;{{ basket.total }}</b>
            </div>
            <discounts :basket="basket"></discounts>
        </div>
    </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    import basket from '@shared/mixins/basket';

    export default {
        props: ['basket', 'services'],
        mixins: [basket],
        components: { Field, ErrorMessage },
        data() {
            return {
                service: [],
                serviceExplainedModalOpen: false,
                deliveryChargeUpdating: false
            }
        },
        mounted() {
            this.emitter.on('deliveryChargeUpdating', (data) => {
                this.deliveryChargeUpdating = data.status;
            });
        },
        methods: {
            serviceInBasket(st_code) {
                if(this.basket.products) {
                    let query = this.basket.products.filter((basket_product) => {
                        return (basket_product.st_code == st_code);
                    });

                    return query.length > 0 ? true : false;
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>